<script setup>

	const url = useRequestURL()

	const { data: page } = await useAPIFetch('Contact')
	const companies = page.value.body.find(item => item.specific === 'Companies')
	const socials = page.value.body.find(item => item.specific === 'Socials')
	const contactLists = page.value.body.filter(item => item.component === 'ContactList')

	const getTitleColor = (type) => {
		switch (type) {
			case 'Executive':
				return "gold"
			case 'Marketing':
				return "lilac"
			case 'Other':
				return "green"
			default:
				return "red"
		}
	}

	useHeadData({
		title: page.value.meta.title,
		description: page.value.meta.description,
		author: page.value.meta.author,
		copyright: page.value.meta.copyright,
		keywords: page.value.meta.keywords,
		og: page.value.meta.og,
		url: url.href
	})

</script>


<template>
	<div class="container mt-10">
		<!-- companies -->
		<div class="xl:grid grid-cols-12 mb-16 xl:mb-32">
			<div class="col-span-4">
				<h1 class="text-red h2">{{ page.attrs.title }}</h1>
			</div>
			<div class="col-span-8">
				<div v-if="companies" class="dark:text-lightText text-dark">
					<div class="md:grid grid-cols-2 gap-8">
						<CompanyInfo v-if="companies.supraphon" :company="companies.supraphon" />
						<CompanyInfo v-if="companies.entertainment" :company="companies.entertainment" entertainment />
					</div>
				</div>
			</div>
		</div>
		<!-- socials -->
		<div class="xl:grid grid-cols-12 mb-16 xl:mb-32">
			<div class="col-span-4">
				<h2 class="text-green">Follow us</h2>
			</div>
			<div class="col-span-8">
				<div v-if="socials" class="dark:text-lightText text-dark mt-4 lg:mt-1.5 -ml-3">
					<Socials :items="socials.items" />
				</div>
			</div>
		</div>

		<!-- contact lists -->
		<div v-for="list in contactLists" :key="list.id" class="xl:grid grid-cols-12 mb-16 xl:mb-32">
			<div class="col-span-4">
				<h2 class="xl:mt-2.5" :class="`text-${getTitleColor(list.specific)}`" v-html="list.title.replace(/\n/g, '<br>')"></h2>
			</div>
			<div class="col-span-8">
				<div class="grid grid-cols-2 gap-8 mt-4">
					<Contact
						v-for="(item, index) in list.items"
						:key="index"
						:name="item.person.attrs.name"
						:surname="item.person.attrs.surname"
						:title="item.person.attrs.title"
						:email="item.person.attrs.email"
						:phone="item.person.attrs.phone"
						:image="item.person.attrs.image"
						:color="getTitleColor(list.specific)"
						:jobTitle="item.job"
					/>
				</div>
			</div>
		</div>

	</div>
</template>